// @ts-strict-ignore
import { List } from "@hubble/web";
import styled from "styled-components";

export const FixedHeightList = styled(List)`
  height: 364px;
  overflow-y: auto;
  margin-left: -12px;
  margin-right: -12px;
  padding-left: 0;
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
`;
